import styled from "styled-components";
import { color } from "../../styles";

export const TextBoxWrapper = styled.input`
    border-radius: 5px;
    border: 1px solid ${color.emphasis.NEUTRAL_N70};
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 10px;
    height: 36px;

    &:focus {
        box-shadow: 0 0 0 2px rgba(0, 88, 160, 0.12);
        outline: none;
        border-color: ${color.primary.BLUE_B100};
    }

    &::placeholder {
        color: ${color.secondary.DARK_GREY};
        font-style: italic;
    }
`;

export const PercentageWrapper = styled.div`
    border-radius: 5px;
    border: 1px solid ${color.emphasis.NEUTRAL_N70};
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 10px;
    height: 36px;
    gap: 6px;
`;
